import ComponentWithSocket from '../../../lib/component';
import { Component, Watch } from 'vue-property-decorator';
import moment from 'moment';
import 'moment/locale/ro';
moment.locale('ro');


@Component
export default class CertificatesList extends ComponentWithSocket {
    public data: {
        currentPage: number;
        lastPage: number;
        perPage: number;
        certificatesCount: number;
        certificates: any[];
        searchQuery: string;
        isSearching: boolean;
    } = {
        currentPage: 1,
        lastPage: 1,
        perPage: 20,
        certificatesCount: 0,
        certificates: [],
        searchQuery: this.$attrs.s ? this.$attrs.s : '',
        isSearching: false
    };

    constructor() {
        super();
    }

    mounted() {
        this.getCertificates();
    }

    @Watch('data.searchQuery')
    onSearchQueryChanged(val: string, oldVal: string) {
        if (!this.data.isSearching) {
            setTimeout(() => {
                this.data.isSearching = false;
                this.data.currentPage = 1;
                this.getCertificates();
            }, 1000);
        }

        this.data.isSearching = true;
    }

    async getCertificates(page: any = this.data.currentPage) {
        let that = this;

        await fetch(`${process.env.API2_URL}/certificate?limit=${this.data.perPage}&page=${page}&search=${this.data.searchQuery}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Eroare: ${response.status}`);
            }

            return response.json();
        }).then(data => {
            if (data && data.success) {
                that.data.certificates = data.data;
                that.data.currentPage = data.currentPage;
                that.data.lastPage = data.lastPage;
                that.data.certificatesCount = data.total;

                data.data.forEach((certificate: any, index: number, arr: number[]) => {
                    certificate.releaseDate = moment(certificate.releaseDate);
                });
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    }

    async removeCertificate(id: number) {
        await fetch(`${process.env.API2_URL}/certificate/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            if (!response.ok) {
                throw new Error(`Eroare: ${response.status}`);
            }

            return response.json();
        }).then(data => {
            if (data && data.success) {
                this.getCertificates();
            }
        }).catch(error => {
            console.error('Error:', error);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/certificates/list/index.ts